import React, { Fragment } from "react"
import { graphql } from "gatsby"
import { injectIntl } from "gatsby-plugin-intl"

import {
  SectionContainer,
  FaqSectionWrapper,
  FaqWrapper,
  FaqLeftDiv,
  FaqRightDiv,
  FaqCategoryListDiv,
  FaqCategoryBoxWrapper,
  FaqCategoryBox,
  FaqCategoryBoxTitle,
  FaqCategoryTitle,
} from "../../../components/Layout/styled"

import Footer from "../../../components/Layout/Footer"
import SeoComp from "../../../components/SeoComp"
import FaqCategorySideBar from "../../../components/FaqCategorySideBar"
import FaqListBreadCrumbSection from "../../../components/FaqListBreadCrumbSection"
import FaqListPrevNextSection from "../../../components/FaqListPrevNextSection"
import FaqSearchSection from "../../../components/Layout/FaqSearchSection"

const FaqCategoryPage = ({ intl, data }) => {
  return (
    data &&
    data.allDirectusFaqPageTranslation.nodes.length > 0 && (
      <Fragment>
        <SeoComp
          description={
            data.allDirectusSeoTranslation.nodes[0] &&
            data.allDirectusSeoTranslation.nodes[0].meta_description
          }
          title={
            data.allDirectusFaqPageTranslation.nodes[0] &&
            data.allDirectusFaqPageTranslation.nodes[0].faq_list &&
            data.allDirectusFaqPageTranslation.nodes[0].faq_list.list &&
            data.allDirectusFaqPageTranslation.nodes[0].faq_list.list.find(
              item => item.key === "an_issue_with_my_order"
            )?.title
          }
          twitter_card={
            data.allDirectusSeoTranslation.nodes[0] &&
            data.allDirectusSeoTranslation.nodes[0].twitter_card
          }
          image={
            data.allDirectusSeoTranslation.nodes[0] &&
            data.allDirectusSeoTranslation.nodes[0].image &&
            data.allDirectusSeoTranslation.nodes[0].image.data &&
            data.allDirectusSeoTranslation.nodes[0].image.data.url
          }
          hreflangPathname={{
            fr: "faq/probleme-sur-ma-commande",
            en: "",
            de: "",
            es: "",
          }}
        />
        <SectionContainer>
          <FaqSearchSection />
          <FaqSectionWrapper>
            {data.allDirectusFaqPageTranslation.nodes[0].faq_list &&
              data.allDirectusFaqPageTranslation.nodes[0].faq_list.list && (
                <FaqListBreadCrumbSection
                  data={data.allDirectusFaqPageTranslation.nodes[0]}
                  sidebarKey={"an_issue_with_my_order"}
                  catPage="true"
                />
              )}
            {data.allDirectusFaqPageTranslation.nodes[0].faq_list &&
              data.allDirectusFaqPageTranslation.nodes[0].faq_list.list && (
                <FaqListPrevNextSection
                  data={
                    data.allDirectusFaqPageTranslation.nodes[0].faq_list.list
                  }
                  sidebarKey={"an_issue_with_my_order"}
                  catPage="true"
                />
              )}
            <FaqWrapper>
              <FaqLeftDiv>
                {data.allDirectusFaqPageTranslation.nodes[0].faq_list &&
                  data.allDirectusFaqPageTranslation.nodes[0].faq_list.list && (
                    <FaqCategorySideBar
                      data={
                        data.allDirectusFaqPageTranslation.nodes[0].faq_list
                          .list
                      }
                      sidebarKey={"an_issue_with_my_order"}
                    />
                  )}
              </FaqLeftDiv>

              <FaqRightDiv>
                <FaqCategoryListDiv>
                  {data.allDirectusFaqPageTranslation.nodes[0] &&
                    data.allDirectusFaqPageTranslation.nodes[0].faq_list &&
                    data.allDirectusFaqPageTranslation.nodes[0].faq_list.list.find(
                      (item, index) => item.key == "an_issue_with_my_order"
                    )?.title && (
                      <FaqCategoryTitle
                        dangerouslySetInnerHTML={{
                          __html: data.allDirectusFaqPageTranslation.nodes[0].faq_list.list.find(
                            (item, index) =>
                              item.key == "an_issue_with_my_order"
                          )?.title,
                        }}
                      />
                    )}
                  {data.allDirectusFaqPageTranslation.nodes[0] &&
                    data.allDirectusFaqPageTranslation.nodes[0].faq_list &&
                    data.allDirectusFaqPageTranslation.nodes[0].faq_list.list
                      .find(
                        (item, index) => item.key == "an_issue_with_my_order"
                      )
                      ?.item_list.map((newItem, newIndex) => {
                        return (
                          newItem && (
                            <FaqCategoryBoxWrapper key={newIndex.toString()}>
                              <FaqCategoryBox to={newItem.item_link}>
                                <FaqCategoryBoxTitle
                                  dangerouslySetInnerHTML={{
                                    __html: newItem.item_title,
                                  }}
                                />
                              </FaqCategoryBox>
                            </FaqCategoryBoxWrapper>
                          )
                        )
                      })}
                </FaqCategoryListDiv>
              </FaqRightDiv>
            </FaqWrapper>
          </FaqSectionWrapper>
        </SectionContainer>

        {data.allDirectusFooterTranslation.nodes.length > 0 && (
          <Footer data={data.allDirectusFooterTranslation.nodes[0]} />
        )}
      </Fragment>
    )
  )
}

export const query = graphql`
  query($lang: String!) {
    site {
      siteMetadata {
        title
      }
    }
    allDirectusFaqPageTranslation(filter: { language: { eq: $lang } }) {
      nodes {
        faq_page_title
        faq_search_title
        faq_article_useful_title
        faq_feedback_success
        faq_list {
          list {
            title
            link
            key
            icon
            item_list {
              item_title
              item_link
            }
          }
        }
      }
    }
    allDirectusFooterTranslation(filter: { language: { eq: $lang } }) {
      nodes {
        facebook
        gbp_facebook
        youtube
        twitter
        instagram
        linkedin
        about_us {
          name
          list {
            link
            list
          }
        }
        contact {
          name
          list {
            link
            list
          }
          button {
            link
            list
          }
        }
        purchases {
          list {
            list
            link
          }
          name
        }
        help {
          list {
            link
            list
          }
          name
        }
        about_us_menu {
          name
          list {
            link
            list
          }
        }
        knowledge_center_menu {
          name
          list {
            link
            list
          }
        }
        shop_menu {
          name
          list {
            link
            list
          }
        }
        support_menu {
          name
          list {
            link
            list
          }
          button {
            link
            list
          }
        }
        newsletter_heading
        follow_us_heading
        footer_bottom {
          list {
            link
            list
          }
        }
      }
    }
    allDirectusSeoTranslation(
      filter: { language: { eq: $lang }, seo: { page_name: { eq: "faq" } } }
    ) {
      nodes {
        meta_title
        meta_description
        twitter_card
        twitter_title
        url
        image {
          data {
            url
          }
        }
      }
    }
  }
`

export default injectIntl(FaqCategoryPage)
